import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation RemoveWishlistProductVariant(\n    $email: String\n    $variantId: ID!\n    $productAttributes: [SelectedAttributeValueInput]\n  ) {\n    wishlistRemoveVariant(\n      email: $email\n      variantId: $variantId\n      productAttributes: $productAttributes\n    ) {\n      # wishlist {\n      #   ...WishlistItem\n      # }\n      errors {\n        field\n        message\n      }\n      wishlistErrors {\n        field\n        message\n        code\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation AddWishlistProductVariant(\n    $email: String\n    $variantId: ID!\n    $productAttributes: [SelectedAttributeValueInput]\n  ) {\n    wishlistAddVariant(\n      email: $email\n      variantId: $variantId\n      productAttributes: $productAttributes\n    ) {\n      # wishlist {\n      #   ...WishlistItem\n      # }\n      errors {\n        field\n        message\n      }\n      wishlistErrors {\n        field\n        message\n        code\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var addWishlistProductVariant = gql(_templateObject());
export var removeWishlistProductVariant = gql(_templateObject2());